import React, { PureComponent } from 'react';
import { Button, Card, CardText, CardTitle } from 'react-md';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import Loader from '../component/Loader';
import TextEditor from '../component/TextEditor';



export default class DynamicData extends PureComponent  {

    constructor(props){
        super(props);
        this.state={            
              DynamicText:"",
              loadingTechTrouble: true,            
              DynamicTextEditorObj: TextEditor.createEmptyValue(),
  
          };
          this.onDynamicTextChange = this.onDynamicTextChange.bind(this);
          this.getDynamicData = this.getDynamicData.bind(this);
          this.updateDynamicdata = this.updateDynamicdata.bind(this);
          
    }
    componentDidMount(){
        this.getDynamicData();
    }
    getDynamicData = async() =>{
        this.setState({loadingTechTrouble:true});
        
        try{
            const payload = {           
                type: this.props.type
            };
            
            let activityResp = await ApiRequestService({
            method: 'post',
            url: "/getDynamicData",
            data: payload
            })
            if(activityResp.data !== undefined && activityResp.data !== null){
                if(activityResp.data.status === 0 &&  activityResp.data.data){
                    var tempDynamicText = activityResp.data.data.text;                    
                    this.setState({
                        DynamicTextEditorObj: TextEditor.createValueFromString(tempDynamicText,'html')
                    });
                }else if (activityResp.data.message !== undefined &&  activityResp.data.message !== null ) {
                    NotificationManager.error(activityResp.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Getting dynamic data failed with Unknown Error","Error",5000);
                }
            }else{
                NotificationManager.error("Getting dynamic data failed with Unknown Error","Error",5000);
            }
            
        }catch(err){
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingTechTrouble:false});
         }
    }
    onDynamicTextChange = value => {
        this.setState({ DynamicTextEditorObj: value });
        //console.debug("value =  ", value);
        let enteredString = TextEditor.getHTMLStringFromEditorState(this.state.DynamicTextEditorObj);
        //console.debug(enteredString.toString());
        if (enteredString !== null) {
          this.setState({ DynamicText: enteredString });
        }
        //console.debug("props onChange ="+this.props.onChange);
      
      };
      updateDynamicdata=()=>{
        
        let tempDynamicDataText = TextEditor.getHTMLStringFromEditorState(this.state.DynamicTextEditorObj);
       
        if (
            (this.state.DynamicText === '' &&
            tempDynamicDataText === '') ||
            tempDynamicDataText === '<p><br></p>'
          ) {
            alert('Please enter the vaild text');
            return ;
          }
          var technicalTrouble_text = TextEditor.getHTMLStringFromEditorState(this.state.DynamicTextEditorObj);
          const payload = {
              type:this.props.type,
              text: technicalTrouble_text
          };
          console.debug('payload', payload);
          ApiRequestService({
            method: 'post',
            url: '/updateDynamicData',
            data: payload
          }).then(res => {
            console.debug('update dynamic data Response : ', res);
            NotificationManager.success('Saved successfully!', 'Success');
          });
          
      }
    render(){


        return (<Card  className="md-block-centered">
                        <CardTitle title={this.props.text}/>
                        <CardText>
                            {this.state.loadingTechTrouble === true ?
                                <Loader loading={this.state.loadingTechTrouble} />
                                :
                            <div>
                                <TextEditor
                                    value={this.state.DynamicTextEditorObj}
                                    onChange={this.onDynamicTextChange}
                                /><br/>
                                <center><Button primary raised onClick = {this.updateDynamicdata} >Save</Button></center>
                            </div>
                            }
                        </CardText>
                    </Card>);

    }
}